<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="subcontractor.subcontractor_name + ' :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <template v-if="$store.state.user.subcontractor_id">
                        <li class="breadcrumb-item font-weight-light">
                            <router-link to="/">
                                <i class="fa fa-id-badge"></i> Dashboard
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-light">
                            <router-link to="/subcontractors/view">
                                {{ subcontractor.subcontractor_name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-light">
                            <router-link to="/subcontractors/qualification/edit">
                                <i class="fa fa-check-square"></i> Pre-Qualification
                            </router-link>
                        </li>
                    </template>
                    <template v-else>
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/subcontractors`">
                                <i class="fa fa-id-badge"></i> Subcontractors
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/subcontractors/view/${subcontractor.subcontractor_id}`">
                                {{ subcontractor.subcontractor_name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/subcontractors/qualification/edit/${subcontractor.subcontractor_id}`">
                                <i class="fa fa-check-square"></i> Pre-Qualification
                            </router-link>
                        </li>
                    </template>
                    <li class="breadcrumb-item active">
                        Review &amp; Submit
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-8 col-lg-12">

                    <b-card class="mb-3">
                        <h6 slot="header" class="mb-0">
                            Section 1: General Information
                            <span class="text-danger" v-if="sectionHasErrors('section_1') > 0">({{ sectionHasErrors('section_1') }}) Issues Found</span>
                        </h6>

                        <template v-if="section_1_loading">
                            <i class="fa fa-circle-o-notch fa-spin"></i> Validating...
                        </template>
                        <template v-else>
                            <div v-if="sectionHasErrors('section_1') > 0" class="text-danger">
                                <ul>
                                    <li v-for="(errors, attribute) in errors.section_1">
                                        <span v-for="(err, index) in errors">
                                            <template v-if="index > 0">,</template> {{ err }}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <div v-else>
                                <span class="text-success text-large"><i class="fa fa-check-circle-o"></i> Validation Passed</span>
                            </div>
                        </template>
                    </b-card>

                    <b-card class="mb-3">
                        <h6 slot="header" class="mb-0">
                            Section 2: Company Information
                            <span class="text-danger" v-if="sectionHasErrors('section_2') > 0">({{ sectionHasErrors('section_2') }}) Issues Found</span>
                        </h6>

                        <template v-if="section_2_loading">
                            <i class="fa fa-circle-o-notch fa-spin"></i> Validating...
                        </template>
                        <template v-else>
                            <div v-if="sectionHasErrors('section_2') > 0" class="text-danger">
                                <ul>
                                    <li v-for="(errors, attribute) in errors.section_2">
                                        <span v-for="(err, index) in errors">
                                            <template v-if="index > 0">,</template> {{ err }}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <div v-else>
                                <span class="text-success text-large"><i class="fa fa-check-circle-o"></i> Validation Passed</span>
                            </div>
                        </template>
                    </b-card>

                    <b-card class="mb-3">
                        <h6 slot="header" class="mb-0">
                            Section 3: Work Performed
                            <span class="text-danger" v-if="sectionHasErrors('section_3') > 0">({{ sectionHasErrors('section_3') }}) Issues Found</span>
                        </h6>

                        <template v-if="section_3_loading">
                            <i class="fa fa-circle-o-notch fa-spin"></i> Validating...
                        </template>
                        <template v-else>
                            <div v-if="sectionHasErrors('section_3') > 0" class="text-danger">
                                <ul>
                                    <li v-for="(errors, attribute) in errors.section_3">
                                        <span v-for="(err, index) in errors">
                                            <template v-if="index > 0">,</template> {{ err }}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <div v-else>
                                <span class="text-success text-large"><i class="fa fa-check-circle-o"></i> Validation Passed</span>
                            </div>
                        </template>
                    </b-card>

                    <b-card class="mb-3">
                        <h6 slot="header" class="mb-0">
                            Section 4: Financial Information
                            <span class="text-danger" v-if="sectionHasErrors('section_4') > 0">({{ sectionHasErrors('section_4') }}) Issues Found</span>
                        </h6>

                        <template v-if="section_4_loading">
                            <i class="fa fa-circle-o-notch fa-spin"></i> Validating...
                        </template>
                        <template v-else>
                            <div v-if="sectionHasErrors('section_4') > 0" class="text-danger">
                                <ul>
                                    <li v-for="(errors, attribute) in errors.section_4">
                                        <span v-for="(err, index) in errors">
                                            <template v-if="index > 0">,</template> {{ err }}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <div v-else>
                                <span class="text-success text-large"><i class="fa fa-check-circle-o"></i> Validation Passed</span>
                            </div>
                        </template>
                    </b-card>


                    <b-card class="mb-3">
                        <h6 slot="header" class="mb-0">
                            Section 5: Safety Information
                            <span class="text-danger" v-if="sectionHasErrors('section_5') > 0">({{ sectionHasErrors('section_5') }}) Issues Found</span>
                        </h6>

                        <template v-if="section_5_loading">
                            <i class="fa fa-circle-o-notch fa-spin"></i> Validating...
                        </template>
                        <template v-else>
                            <div v-if="sectionHasErrors('section_5') > 0" class="text-danger">
                                <ul>
                                    <li v-for="(errors, attribute) in errors.section_5">
                                        <span v-for="(err, index) in errors">
                                            <template v-if="index > 0">,</template> {{ err }}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <div v-else>
                                <span class="text-success text-large"><i class="fa fa-check-circle-o"></i> Validation Passed</span>
                            </div>
                        </template>
                    </b-card>

                    <b-card class="mb-3">
                        <h6 slot="header" class="mb-0">
                            Section 6: Insurance Information
                            <span class="text-danger" v-if="sectionHasErrors('section_6') > 0">({{ sectionHasErrors('section_6') }}) Issues Found</span>
                        </h6>

                        <template v-if="section_6_loading">
                            <i class="fa fa-circle-o-notch fa-spin"></i> Validating...
                        </template>
                        <template v-else>
                            <div v-if="sectionHasErrors('section_6') > 0" class="text-danger">
                                <ul>
                                    <li v-for="(errors, attribute) in errors.section_6">
                                        <span v-for="(err, index) in errors">
                                            <template v-if="index > 0">,</template> {{ err }}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <div v-else>
                                <span class="text-success text-large"><i class="fa fa-check-circle-o"></i> Validation Passed</span>
                            </div>
                        </template>
                    </b-card>

                    <b-card class="mb-3">
                        <h6 slot="header" class="mb-0">
                            Section 7: Bonding Information
                            <span class="text-danger" v-if="sectionHasErrors('section_7') > 0">({{ sectionHasErrors('section_7') }}) Issues Found</span>
                        </h6>

                        <template v-if="section_7_loading">
                            <i class="fa fa-circle-o-notch fa-spin"></i> Validating...
                        </template>
                        <template v-else>
                            <div v-if="sectionHasErrors('section_7') > 0" class="text-danger">
                                <ul>
                                    <li v-for="(errors, attribute) in errors.section_7">
                                        <span v-for="(err, index) in errors">
                                            <template v-if="index > 0">,</template> {{ err }}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <div v-else>
                                <span class="text-success text-large"><i class="fa fa-check-circle-o"></i> Validation Passed</span>
                            </div>
                        </template>
                    </b-card>

                    <b-card class="mb-3">
                        <h6 slot="header" class="mb-0">
                            Section 8: Past Performance
                            <span class="text-danger" v-if="sectionHasErrors('section_8') > 0">({{ sectionHasErrors('section_8') }}) Issues Found</span>
                        </h6>

                        <template v-if="section_8_loading">
                            <i class="fa fa-circle-o-notch fa-spin"></i> Validating...
                        </template>
                        <template v-else>
                            <div v-if="sectionHasErrors('section_8') > 0" class="text-danger">
                                <ul>
                                    <li v-for="(errors, attribute) in errors.section_8">
                                        <span v-for="(err, index) in errors">
                                            <template v-if="index > 0">,</template> {{ err }}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <div v-else>
                                <span class="text-success text-large"><i class="fa fa-check-circle-o"></i> Validation Passed</span>
                            </div>
                        </template>
                    </b-card>

                    <b-card class="mb-3">
                        <h6 slot="header" class="mb-0">
                            Section 9: References
                            <span class="text-danger" v-if="sectionHasErrors('section_9') > 0">({{ sectionHasErrors('section_9') }}) Issues Found</span>
                        </h6>

                        <template v-if="section_9_loading">
                            <i class="fa fa-circle-o-notch fa-spin"></i> Validating...
                        </template>
                        <template v-else>
                            <div v-if="sectionHasErrors('section_9') > 0" class="text-danger">
                                <ul>
                                    <li v-for="(errors, attribute) in errors.section_9">
                                        <span v-for="(err, index) in errors">
                                            <template v-if="index > 0">,</template> {{ err }}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <div v-else>
                                <span class="text-success text-large"><i class="fa fa-check-circle-o"></i> Validation Passed</span>
                            </div>
                        </template>
                    </b-card>

                    <b-card class="mb-3">
                        <h6 slot="header" class="mb-0">
                            Section 10: EEO &amp; Eligibility to Work
                            <span class="text-danger" v-if="sectionHasErrors('section_10') > 0">({{ sectionHasErrors('section_10') }}) Issues Found</span>
                        </h6>

                        <template v-if="section_10_loading">
                            <i class="fa fa-circle-o-notch fa-spin"></i> Validating...
                        </template>
                        <template v-else>
                            <div v-if="sectionHasErrors('section_10') > 0" class="text-danger">
                                <ul>
                                    <li v-for="(errors, attribute) in errors.section_10">
                                        <span v-for="(err, index) in errors">
                                            <template v-if="index > 0">,</template> {{ err }}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <div v-else>
                                <span class="text-success text-large"><i class="fa fa-check-circle-o"></i> Validation Passed</span>
                            </div>
                        </template>
                    </b-card>

                </div>
                <div class="col-xl-4 col-lg-12">
                    <b-card>
                        <h6 slot="header">Review Summary</h6>

                        <div class="row">
                            <div class="col text-muted">Total Issues Found:</div>
                            <div class="col-md-5">{{ totalIssues }}</div>
                        </div>
                        <hr/>

                        <template v-if="validationInProgress == false && totalIssues == 0">
                            <button type="submit" class="btn btn-success" v-on:click="submitForm()" :disabled="submitting" v-if="canSubmit">
                                <template v-if="submitting">
                                    <i class="fa fa-circle-o-notch  fa-spin"></i> Submitting...
                                </template>
                                <template v-else>
                                    Submit Pre-Qualification Form
                                </template>
                            </button>
                            <div class="alert alert-warning" v-else>
                                You are not authorized to submit pre-qualification forms. Contact a Subcontractor Manager.
                            </div>
                        </template>
                        <template v-else-if="validationInProgress == false && totalIssues > 0">
                            <div class="alert alert-warning">You have to correct the issues found before submitting your application</div>
                            <router-link :to="'/subcontractors/qualification/edit' + (subcontractor_id ? '/' + subcontractor_id : '')" class="btn btn-primary"><i class="fa fa-arrow-left"></i> Back to Pre-Qualification Form</router-link>
                        </template>
                        <template v-else>
                            <i class="fa fa-circle-o-notch fa-spin"></i> Validation In Progress
                        </template>
                    </b-card>
                    <b-card class="mt-3" v-if="validationInProgress == false && totalIssues > 0">
                        <b-button variant="warning" v-on:click="reValidate()">Re-run Validation <i class="fa fa-refresh"></i></b-button>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                submitting: false,
                validationInProgress: true,
                totalIssues: 0,
                subcontractor_id: this.$route.params.id,
                subcontractor: {},
                section_1_loading: true,
                section_2_loading: true,
                section_3_loading: true,
                section_4_loading: true,
                section_5_loading: true,
                section_6_loading: true,
                section_7_loading: true,
                section_8_loading: true,
                section_9_loading: true,
                section_10_loading: true,
                errors: {
                    section_1: [],
                    section_2: [],
                    section_3: [],
                    section_4: [],
                    section_5: [],
                    section_6: [],
                    section_7: [],
                    section_8: [],
                    section_9: [],
                    section_10: [],
                }
            }
        },

        watch: {
            validationInProgress(newVal, oldVal){
                //IF the new value == false and there are NO errors, fire the submit
                if(newVal === false && this.totalIssues === 0 && this.canSubmit)
                {
                    //Submit it
                    this.submitForm();
                }
            },
        },

        computed: {
            canSubmit(){
                //Check Permission
                if(this.$root.hasPermission(['subcontractors.manage', 'subcontractors.submit']))
                {
                    return true;
                }

                //IF the current user is the subcontractor who is editing
                if(this.$store.state.user.subcontractor_id == this.subcontractor.subcontractor_id)
                {
                    return true;
                }

                //Send false
                return false;
            },
        },

        methods: {

            getSubcontractor() {
                //Get the data
                this.$http
                    .get('subcontractors/review' + (this.subcontractor_id ? '/' + this.subcontractor_id : ''))
                    .then(response => {
                        //Set all the data
                        this.subcontractor = response.data;

                        //Set loading
                        this.loading = false;

                        //Start the Chain
                        this.verifySection(1);
                    })
                    .catch(response => {

                    });
            },

            verifySection(sectionNumber){
                //Send it
                this.$http
                    .get('subcontractors/validate' + (this.subcontractor_id ? '/' + this.subcontractor_id : ''), {section: sectionNumber})
                    .then(response => {
                        //Set the error if any
                        this.errors['section_'+sectionNumber] = response.data;

                        this.totalIssues += this.sectionHasErrors('section_'+sectionNumber);

                        //Set Loading
                        this['section_'+sectionNumber+'_loading'] = false;

                        //Start the Chain
                        if(sectionNumber < 10)
                        {
                            this['verifySection']((sectionNumber + 1));
                        }
                        else
                        {
                            //Mark Complete
                            this.validationInProgress = false;
                        }
                    })
                    .catch(response => {

                    });
            },

            sectionHasErrors(key){
                //Return the inverst
                return Object.keys(this.errors[key]).length;
            },

            resetSections(){
                this.errors = {
                    section_1: [],
                    section_2: [],
                    section_3: [],
                    section_4: [],
                    section_5: [],
                    section_6: [],
                    section_7: [],
                    section_8: [],
                    section_9: [],
                    section_10: [],
                };
            },

            submitForm(){
                //Submitting
                this.submitting = true;

                //SEnd it
                this.$http.post('subcontractors/submit' + (this.subcontractor_id ? '/' + this.subcontractor_id : ''))
                    .then(response => {
                        //Alert the user
                        this.$toastr.success('All Qualification Managers have been notified. The '+this.$store.state.user.account_name+' prequalification team will reach out to you for any additional information.', 'Qualification Submitted');

                        //Return to where?
                        this.$router.push('/subcontractors/qualification/view' + (this.$store.state.user.subcontractor_id ? '' : '/'+this.subcontractor_id));
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Reset
                        this.submitting = false;
                    });
            },

            reValidate(){
                //Set Helpers
                this.validationInProgress = true;

                //Reset
                this.totalIssues = 0;

                //Reset Stuff
                var sectionIndex = 1;

                while(sectionIndex <= 10)
                {
                    //Set Errors
                    this.errors['section_'+sectionIndex] = {};

                    //Set loading
                    this['section_'+sectionIndex+'_loading'] = true;
                    //Increment
                    sectionIndex++;
                }

                //Set it
                this.verifySection(1);
            },

        },

        mounted() {
            //Get the subcontractors
            this.getSubcontractor();
        }
    }
</script>
